const template = require('./asset_classes.html.slim');
const controller = require('./asset_classes_controller');

angular.module('wbComponents').directive('assetClasses', () => ({
  restrict: 'E',
  controller,
  controllerAs: 'ctrl',
  templateUrl: template,
  link: ($scope, $el, $attrs) => {},
}));
